function loginErrorText(error) {
  if (!error) return ''
  if (typeof error === 'string') return error.trim()
  return String(error.message || error.name || '').trim()
}

export function formatLoginErrorMessage(error, fallback = 'Could not send verification code.') {
  const message = loginErrorText(error)
  if (!message) return fallback

  const normalized = message.toLowerCase()

  if (
    normalized.includes('not_authorized') ||
    normalized.includes('notauthorized') ||
    normalized.includes('kindly signup') ||
    normalized.includes('usernotfound') ||
    normalized.includes('user does not exist') ||
    normalized.includes('user not found') ||
    normalized.includes('defineauthchallenge')
  ) {
    return 'No account found for this email address. Please contact your administrator.'
  }

  if (
    normalized.includes('incorrect otp') ||
    normalized.includes('invalid code') ||
    normalized.includes('code mismatch')
  ) {
    return 'Incorrect verification code. Please try again.'
  }

  if (normalized.includes('invalid session for the user')) {
    return 'Your verification session expired. Please request a new code.'
  }

  if (
    normalized.includes('limit exceeded') ||
    normalized.includes('too many attempts') ||
    normalized.includes('too many requests')
  ) {
    return 'Too many attempts. Please wait a moment and try again.'
  }

  if (
    normalized.includes('failed with error') ||
    normalized.includes('lambda') ||
    normalized.includes('error:')
  ) {
    return 'Unable to sign in with this email. Please check the address or contact support.'
  }

  return message
}
